//import CircularProgress from "@material-ui/core/CircularProgress";
//import { green } from "@material-ui/core/colors";
//import LinearProgress from "@material-ui/core/LinearProgress";
//import { makeStyles } from "@material-ui/core/styles";
//import clsx from "clsx";
//import React, { useState } from "react";
//import { connect } from "react-redux";
//import { Link } from "react-router-dom";
//import { userLoginFetch } from "../actions/authActions";
//import { getDocs } from "../actions/getDocs";
//import { loadBioData } from "../actions/loadBioData";
//import { loadRoutes } from "../actions/loadRoutes";
//import LoginWithOTP from "./LoginWithOTP"
//import { IP } from "../config/IP";
//import store from "../store/createStore";
//import "./Login.css";
//import Tabs from '@mui/material/Tabs';
//import Tab from '@mui/material/Tab';
//
//const useStyles = makeStyles((theme) => ({
//	root: {
//		width: "100%",
//		"& > * + *": {
//			marginTop: theme.spacing(2),
//		},
//		display: "flex",
//		alignItems: "center",
//	},
//	wrapper: {
//		margin: theme.spacing(1),
//		position: "relative",
//	},
//	buttonSuccess: {
//		backgroundColor: green[500],
//		"&:hover": {
//			backgroundColor: green[700],
//		},
//	},
//	fabProgress: {
//		color: green[500],
//		position: "absolute",
//		top: -6,
//		left: -6,
//		zIndex: 1,
//	},
//	buttonProgress: {
//		color: green[500],
//		position: "absolute",
//		top: "50%",
//		left: "50%",
//		marginTop: -12,
//		marginLeft: -12,
//	},
//}));
//
//function Login(props) {
//	const classes = useStyles();
//	const [loading, setLoading] = React.useState(false);
//	const [success, setSuccess] = React.useState(false);
//	const timer = React.useRef();
//
//	const buttonClassname = clsx({
//		[classes.buttonSuccess]: success,
//	});
//	const [state, setState] = useState({
//		username: "",
//		password: "",
//	});
//	React.useEffect(() => {
//		return () => {
//			clearTimeout(timer.current);
//		};
//	}, []);
//
//	const handleChange = (event) => {
//		setState({ ...state, [event.target.name]: event.target.value });
//	};
//
//	const handleSubmit = (event) => {
//		event.preventDefault();
//		if (!loading) {
//			setSuccess(false);
//			setLoading(true);
//			timer.current = setTimeout(() => {
//				setSuccess(true);
//				setLoading(false);
//			}, 5000);
//		}
//		props.userLoginFetch(state).then((output) => {
//			let inputs = {
//				url: IP.nodeServer + "api/routesRules",
//				method: "POST",
//				data: [{ name: "Doc_type_id", value: 1 }],
//			};
//
//			console.log(
//				"store.getState() after props.loadRoutes =",
//				store.getState()
//			);
//			console.log("output=", output);
//		});
//		console.log("handleSubmit state=", state);
//	};
//	const [value, setValue] = React.useState(0);
//
//	const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
//		console.log("handle Login handleChangeTab newValue=", newValue)
//		setValue(newValue);
//	};
//
//
//
//	return (
//		<div>
//
//			<div className={classes.root}>
//
//				<div className="login">
//					<Tabs value={value} onChange={handleChangeTab} aria-label="disabled tabs example">
//						<Tab label="Active Eligible Staff" />
//						<Tab label="Inactive Eligible former Staff" />
//					</Tabs>
//					<div className="login-triangle"></div>
//
//					<h2 className="login-header">Log in</h2>
//					{value === 0 ?
//						<form className="login-container" onSubmit={handleSubmit}>
//							<p>
//								<input
//									name="username"
//									placeholder="Username"
//									value={state.username}
//									onChange={handleChange}
//								/>
//							</p>
//
//							<p>
//								<input
//									type="password"
//									name="password"
//									placeholder="Password"
//									value={state.password}
//									onChange={handleChange}
//								/>
//							</p>
//							<div className={classes.wrapper}>
//								<input
//									type="submit"
//									className={buttonClassname}
//									disabled={loading}
//								/>
//
//								{loading && (
//									<CircularProgress size={24} className={classes.buttonProgress} />
//								)}
//								{false && <Link to="/Register">Register</Link>}
//							</div>
//						</form> : <div className="bg-white"><LoginWithOTP /></div>}
//					<div style={{ color: 'red' }} >{props.state.auth.errorappMessage ? props.state.auth.errorappMessage : ""}
//						{props.state.auth.isLoading ? <LinearProgress variant="query" /> : ""}</div>
//				</div>
//
//
//			</div>
//
//
//		</div>
//	);
//}
//
/////const mapStateToProps = state => ({ authReducer: state.authReducer });
//const mapStateToProps = (state) => ({ state });
//
//const mapDispatchToProps = (dispatch) => ({
//	userLoginFetch: (userInfo) => dispatch(userLoginFetch(userInfo)),
//	loadRoutes: (data) => dispatch(loadRoutes(data)),
//	getDocs: (data) => dispatch(getDocs(data)),
//	loadBioData: (data) => dispatch(loadBioData(data)),
//});
//
//export default connect(mapStateToProps, mapDispatchToProps)(Login);

import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import LinearProgress from "@material-ui/core/LinearProgress";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import React, { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { userLoginFetch } from "../actions/authActions";
import { getDocs } from "../actions/getDocs";
import { loadBioData } from "../actions/loadBioData";
import { loadRoutes } from "../actions/loadRoutes";
import logo from "../assets/images/white_logo.png";
import { IP } from "../config/IP";
import store from "../store/createStore";
import "./Login.css";

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		"& > * + *": {
			marginTop: theme.spacing(2),
		},
		display: "flex",
		alignItems: "center",
	},
	wrapper: {
		margin: theme.spacing(1),
		position: "relative",
	},
	buttonSuccess: {
		backgroundColor: green[500],
		"&:hover": {
			backgroundColor: green[700],
		},
	},
	fabProgress: {
		color: green[500],
		position: "absolute",
		top: -6,
		left: -6,
		zIndex: 1,
	},
	buttonProgress: {
		color: green[500],
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -12,
		marginLeft: -12,
	},
}));

function Login(props) {
	const classes = useStyles();
	const [loading, setLoading] = React.useState(false);
	const [success, setSuccess] = React.useState(false);
	const timer = React.useRef();

	const buttonClassname = clsx({
		[classes.buttonSuccess]: success,
	});
	const [state, setState] = useState({
		username: "",
		password: "",
		isCateringStaff: false,
	});
	React.useEffect(() => {
		return () => {
			clearTimeout(timer.current);
		};
	}, []);

	const handleChange = (event) => {
		const { name, type, checked, value } = event.target;
		setState({ ...state, [name]: type === "checkbox" ? checked : value });
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		if (!loading) {
			setSuccess(false);
			setLoading(true);
			timer.current = setTimeout(() => {
				setSuccess(true);
				setLoading(false);
			}, 5000);
		}
		props.userLoginFetch(state).then((output) => {
			let inputs = {
				url: IP.nodeServer + "api/routesRules",
				method: "POST",
				data: [{ name: "Doc_type_id", value: 1 }],
			};

			console.log(
				"store.getState() after props.loadRoutes =",
				store.getState()
			);
			console.log("output=", output);
		});
		console.log("handleSubmit state=", state);
	};

	console.log("props.state.auth ", props.state.auth);

	return (
		<div className="auth">

			<div className="login">
				{/* <Tabs value={value} onChange={handleChangeTab} aria-label="disabled tabs example">
					<Tab label="Active Eligible Staff" />
					<Tab label="Inactive Eligible former Staff" />
				</Tabs> */}
				{/* <div className="login-triangle"></div> */}

				{/* <h2 className="login-header">Log in</h2> */}
				<img src={logo} alt="RwandAir Logo" className="login-logo" />
				{/* {value === 0 ? */}
				<form className="login-container" onSubmit={handleSubmit}>
					<span className="login-heading">RwandAir MyWork System</span>
					<span className="login-subheading">Enter your WB Credentials to access My work application</span>
					<p>
						<input
							name="username"
							type="text"
							className="username-input"
							placeholder="Enter your username"
							value={state.username}
							onChange={handleChange}
						/>
					</p>

					<p>
						<input
							type="password"
							name="password"
							placeholder="Password"
							value={state.password}
							onChange={handleChange}
						/>
					</p>
					<div className="actions">
						<div className="catering-action">
							<input
								type="checkbox"
								id="rememberMe"
								name="isCateringStaff"
								checked={state.isCateringStaff}
								onChange={handleChange}
							/>
							<label className="remember-me" htmlFor="rememberMe">RwandAir Catering Staff?</label>
							{/* <a href="#" className="forgot-password">Forgot password?</a> */}
						</div>
						<Link className="former-staff-link" to="/formerstafflogin">Former & Eligible Staff?</Link>
					</div>
					<div className={classes.wrapper}>
						<input
							type="submit"
							className={buttonClassname}
							disabled={loading}
						/>

						{loading && (
							<CircularProgress size={24} className={classes.buttonProgress} />
						)}
						{false && <Link to="/Register">Register</Link>}
					</div>
				</form>
					 {/* <div className="bg-white"><LoginWithOTP /></div> */}
					
				<div style={{ color: 'red' }} >{props.state.auth.errorappMessage ? props.state.auth.errorappMessage : ""}
					{props.state.auth.isLoading ? <LinearProgress variant="query" /> : ""}</div>
			</div>
		</div>
	);
}

///const mapStateToProps = state => ({ authReducer: state.authReducer });
const mapStateToProps = (state) => ({ state });

const mapDispatchToProps = (dispatch) => ({
	userLoginFetch: (userInfo) => dispatch(userLoginFetch(userInfo)),
	loadRoutes: (data) => dispatch(loadRoutes(data)),
	getDocs: (data) => dispatch(getDocs(data)),
	loadBioData: (data) => dispatch(loadBioData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
